//lib and utils
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { BREAKPOINT } from 'src/app-lang';
import { Route, Redirect, browserHistory, Switch, useRouterHistory  } from 'react-router';
import createBrowserHistory from 'history/createBrowserHistory';
import { createHistory } from 'history';
import { Router } from 'react-router-dom';
import debounce from 'lodash/debounce';
import ReactGA from 'react-ga';
//polyfill
require( 'array.prototype.fill' );
// GA initialize
ReactGA.initialize('UA-12305317-5');
//Store
import AppStore from './app-store';
//utils
import { checkUserAgent } from 'utils/utils';
//action-creators
import { getViewportSize } from './app-dux';
//Global Components
import	Header from './header/header';
import	Footer from './footer/footer';
import Sales from '../src/sales-tools/sales-tools.jsx';
import News from '../src/news/news.jsx';
//Home Components

import Login from './login/login';
//shared components
import { Loader } from 'src/shared/loader/loader';

function enroll( callback ) {
	require.ensure( [], function( require ) {
		callback( require( '../src/enroll/enroll.jsx' ).default );
	}, 'enrollPage' );
}

class Enroll extends React.Component {
	constructor( props ) {
		super( props );
	}
	componentWillMount() {
		this.props.setRequireComponent("enrollPage", null);
		enroll( ( component ) => {
			this.props.setRequireComponent("enrollPage", React.createElement( component, this.props ));
		} );
			
		}
	render() {
		return this.props.component ? this.props.component : null;
	}
}

function requireEmailVerification( callback ) {
	require.ensure( [], function( require ) {
		callback( require( '../src/email-verification/email-verification.jsx' ).default );
	}, 'emailVerificationPage' );
}

class RequireEmailVerification extends React.Component {
	constructor( props ) {
		super( props );        
	}
	componentWillMount() {
		this.props.setRequireComponent("emailVerificationPage", null);
		requireEmailVerification( ( component ) => {
			this.props.setRequireComponent("emailVerificationPage", React.createElement( component, this.props ));
		} );
			
		}
	render() {
		return this.props.component ? this.props.component : null;
	}
}

function requireTandCpage( callback ) {
	require.ensure( [], function( require ) {
		callback( require( '../src/terms-conditions/terms-conditions.jsx' ).default );
	}, 'TandCpage' );
}

class RequireTandC extends React.Component {
	constructor( props ) {
		super( props );        
	}
	componentWillMount() {
		this.props.setRequireComponent("TandCpage", null);
		requireTandCpage( ( component ) => {
			this.props.setRequireComponent("TandCpage", React.createElement( component, this.props ));
		} );
			
		}
	render() {
		return this.props.component ? this.props.component : null;
	}
}

function requirePrivacyPolicyPage( callback ) {
	require.ensure( [], function( require ) {
		callback( require( '../src/privacy-policy/privacy-policy.jsx' ).default );
	}, 'privacyPolicyPage' );
}

class RequirePrivacyPolicy extends React.Component {
	constructor( props ) {
		super( props );
	}
	componentWillMount() {
		this.props.setRequireComponent("privacyPolicyPage", null);
		requirePrivacyPolicyPage( ( component ) => {
			this.props.setRequireComponent("privacyPolicyPage", React.createElement( component, this.props ));
		} );
			
		}
	render() {
		return this.props.component ? this.props.component : null;
	}
}

function requireFAQ( callback ) {
	require.ensure( [], function( require ) {
		callback( require( '../src/faq/faq.jsx' ).default );
	}, 'faqPage' );
}

class RequireFAQ extends React.Component {
	constructor( props ) {
		super( props );
	}
	componentWillMount() {
		this.props.setRequireComponent("faqPage", null);
		requireFAQ( ( component ) => {
			this.props.setRequireComponent("faqPage", React.createElement( component, this.props ));
		} );
			
		}
	render() {
		return this.props.component ? this.props.component : null;
	}
}

function requireNews( callback ) {
	require.ensure( [], function( require ) {
		callback( require( '../src/news/news.jsx' ).default );
	}, 'newsPage' );
}

class RequireNews extends React.Component {
	constructor( props ) {
		super( props );
	}
	componentWillMount() {
		this.props.setRequireComponent("newsPage", null);
		requireNews( ( component ) => {
			this.props.setRequireComponent("newsPage", React.createElement( component, this.props ));
		} );
			
		}
	render() {
		return this.props.component ? this.props.component : null;
	}
}

function requireProfile( callback ) {
	require.ensure( [], function( require ) {
		callback( require( '../src/profile/profile.jsx' ).default );
	}, 'profilePage' );
}

class RequireProfile extends React.Component {
	constructor( props ) {
		super( props );
	}
	componentWillMount() {
		this.props.setRequireComponent("profilePage", null);
		requireProfile( ( component ) => {
			this.props.setRequireComponent("profilePage", React.createElement( component, this.props ));
		} );
			
		}
	render() {
		return this.props.component ? this.props.component : null;
	}
}

function requireForgotPassword( callback ) {
	require.ensure( [], function( require ) {
		callback( require( '../src/forgot-password/forgot-password.jsx' ).default );
	}, 'forgotPasswordPage' );
}

class RequireForgotPassword extends React.Component {
	constructor( props ) {
		super( props );
	}
	componentWillMount() {
		this.props.setRequireComponent("forgotPasswordPage", null);
		requireForgotPassword( ( component ) => {
			this.props.setRequireComponent("forgotPasswordPage", React.createElement( component, this.props ));
		} );
			
		}
	render() {
		return this.props.component ? this.props.component : null;
	}
}

function requireUpdatePassword( callback ) {
	require.ensure( [], function( require ) {
		callback( require( '../src/update-password/update-password.jsx' ).default );
	}, 'updatePasswordPage' );
}

class RequireUpdatePassword extends React.Component {
	constructor( props ) {
		super( props );
	}
	componentWillMount() {
		this.props.setRequireComponent("updatePasswordPage", null);
		requireUpdatePassword( ( component ) => {
			this.props.setRequireComponent("updatePasswordPage", React.createElement( component, this.props ));
		} );
			
		}
	render() {
		return this.props.component ? this.props.component : null;
	}
}

function requireContact( callback ) {
	require.ensure( [], function( require ) {
		callback( require( '../src/contact-us/contact.jsx' ).default );
	}, 'contactPage' );
}

class RequireContact extends React.Component {
	constructor( props ) {
		super( props );
	}
	componentWillMount() {
		this.props.setRequireComponent("contactPage", null);
		requireContact( ( component ) => {
			this.props.setRequireComponent("contactPage", React.createElement( component, this.props ));
		} );
			
		}
	render() {
		return this.props.component ? this.props.component : null;
	}
}

function requireRefer( callback ) {
	require.ensure( [], function( require ) {
		callback( require( '../src/refer-earn/referAndEarn.jsx' ).default );
	}, 'referPage' );
}

class RequireRefer extends React.Component {
	constructor( props ) {
		super( props );
	}
	componentWillMount() {
		this.props.setRequireComponent("referPage", null);
		requireRefer( ( component ) => {
			this.props.setRequireComponent("referPage", React.createElement( component, this.props ));
		} );
			
		}
	render() {
		return this.props.component ? this.props.component : null;
	}
}

function requireSpinWin( callback ) {
	require.ensure( [], function( require ) {
		callback( require( '../src/spin2win/spin-win.jsx' ).default );
	}, 'spinWinPage' );
}

class RequireSpinWin extends React.Component {
	constructor( props ) {
		super( props );
	}
	componentWillMount() {
		this.props.setRequireComponent("spinWinPage", null);
		requireSpinWin( ( component ) => {
			this.props.setRequireComponent("spinWinPage", React.createElement( component, this.props ));
		} );
			
		}
	render() {
		return this.props.component ? this.props.component : null;
	}
}

function requireHome( callback ) {
	require.ensure( [], function( require ) {
		callback( require( '../src/views/home/home.jsx' ).default );
	}, 'homePage' );
}

class RequireHome extends React.Component {
	constructor( props ) {
		super( props );
	}
	componentWillMount() {
		this.props.setRequireComponent("homePage", null);
		requireHome( ( component ) => {
			this.props.setRequireComponent("homePage", React.createElement( component, this.props ));
		} );
			
		}
	render() {
		return this.props.component ? this.props.component : null;
	}
}

/*
 *	create routerHistory
 */
//const routerHistory = createBrowserHistory();

const routerHistory = createBrowserHistory({
    basename: "/wholesalechannelpartners/nkl-api"    
});

/*
 * AppProvider assigns our AppStore and runs IE support functions
 */
export default class AppProvider extends React.Component {
	componentWillMount() {
		checkUserAgent();
	}
	render () {
		return (
			<Provider store={ AppStore }>
				<WRAPPER />
			</Provider>
		);
	}
}

/*
 * Main container for the app
 */

export class WRAPPER extends React.Component {
	constructor(props){
		super(props);
		this.state = {
			requireComponents: {},
            currentLink: ''
		}
	}
	
	setRequireComponent = ( name ,componentObject ) => {
		this.setState((state) => {
		
			let newRequireComponents = state.requireComponents;
			newRequireComponents[name] = componentObject;
			return {
				...state,
				requireComponents: newRequireComponents
			}
		});
	}
	
	componentWillMount() {
		this.props.getViewportSize();
	}

	componentDidMount() {
		window.addEventListener( 'resize', debounce( this.resizeEvent.bind( this ), 100 ) );        
	}

	componentWillUnmount() {
		window.removeEventListener( 'resize', debounce( this.resizeEvent.bind( this ), 100 ) );        
	}
    
    componentWillReceiveProps(nextProps) {
        ReactGA.set({ page: location.pathname });
        ReactGA.pageview(location.pathname);
    }

	resizeEvent() {
		this.props.getViewportSize();
	}   
    
	render() {
		const{
			app: {
				viewport, fetching
			}
		} = this.props;
		return(
			<Router history={routerHistory}>
				<div className="wrapper-outer">
                    <div className="wrapper-inner">
                        {
                            <Header viewportWidth={ viewport.width } />
                        }
                        <div className="content-wrapper wholesalechannelpartners">
                            <Switch>
								
								<Route exact path={'/enroll'} render = { () => {
									return <Enroll key={this.state.currentLink} setRequireComponent={this.setRequireComponent} component={this.state.requireComponents.enrollPage} />;
                                }}/>
								
								<Route exact path={'/emailVerification'} render = { () => {
                                    return <RequireEmailVerification key={this.state.currentLink} setRequireComponent={this.setRequireComponent} component={this.state.requireComponents.emailVerificationPage} />;
                                }}/>
								
								<Route exact path={'/terms'} render = { () => {
                                    return <RequireTandC key={this.state.currentLink} setRequireComponent={this.setRequireComponent} component={this.state.requireComponents.TandCpage} />;
                                }}/>
								
								<Route exact path={'/privacy'} render = { () => {
                                    return <RequirePrivacyPolicy key={this.state.currentLink} setRequireComponent={this.setRequireComponent} component={this.state.requireComponents.privacyPolicyPage} />;
                                }}/>
								
								<Route exact path={'/about'} render = { () => {
                                    return <RequireFAQ key={this.state.currentLink} setRequireComponent={this.setRequireComponent} component={this.state.requireComponents.faqPage} />;
                                }}/>
								
								<Route exact path={'/news'} component={News}/>
								
								<Route exact path={'/profile'} render = { () => {
                                    return <RequireProfile key={this.state.currentLink} setRequireComponent={this.setRequireComponent} component={this.state.requireComponents.profilePage} />;
                                }}/>
								
								<Route exact path={'/sales'} component={Sales}/>
								
								<Route exact path={'/forgotpassword'} render = { () => {
                                    return <RequireForgotPassword key={this.state.currentLink} setRequireComponent={this.setRequireComponent} component={this.state.requireComponents.forgotPasswordPage} />;
                                }}/>
								
								<Route exact path={'/updatepassword'} render = { () => {
                                    return <RequireUpdatePassword key={this.state.currentLink} setRequireComponent={this.setRequireComponent} component={this.state.requireComponents.updatePasswordPage} />;
                                }}/>
								
								<Route exact path={'/contact'} render = { () => {
                                    return <RequireContact key={this.state.currentLink} setRequireComponent={this.setRequireComponent} component={this.state.requireComponents.contactPage} />;
                                }}/>

								<Route exact path={'/refer'} render = { () => {
                                    return <RequireRefer key={this.state.currentLink} setRequireComponent={this.setRequireComponent} component={this.state.requireComponents.referPage} />;
                                }}/>
								
								<Route exact path={'/spin'} render = { () => {
                                    return <RequireSpinWin key={this.state.currentLink} setRequireComponent={this.setRequireComponent} component={this.state.requireComponents.spinWinPage} />;
                                }}/>
								
								<Route exact path={'/home'} render = { () => {
                                    return <RequireHome key={this.state.currentLink} setRequireComponent={this.setRequireComponent} component={this.state.requireComponents.homePage} />;
                                }}/>
								
								<Route path={'/login'} render={ () => { return <Login />; } }/>
								<Route path={'/'} render={ () => { return <Login />; } }/>								
								
                            </Switch>
                        </div>

                        <Loader
                            fetching={ fetching }
                            type="app"
                            overlayHeight={ viewport.height }
                            fetchCodes={ [ 'fetchNavigation' ] } />
						<Footer />
                    </div>
				</div>
			</Router>
		);
	}
}


WRAPPER = connect(
	( state ) => {
		return {
			app: state.app,
			header: state.header
		};
	},
	( dispatch ) => bindActionCreators( { getViewportSize }, dispatch )
)( WRAPPER );

const appRoot = document.getElementById( 'app-root' );
if( appRoot ) {
	render(
		<AppProvider />,
		appRoot
	);
}



// WEBPACK FOOTER //
// ./src/app.jsx